"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldPicker = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const useWorkflowFields_1 = require("../hooks/useWorkflowFields");
const useFindTaskTypeById_1 = require("../task-types/hooks/useFindTaskTypeById");
const FieldPicker = props => {
    const { taskTypeId, value: selected, hideCustomFields, onChange } = props;
    const { data, isLoading, error, get } = (0, useFindTaskTypeById_1.useFindTaskTypeById)(taskTypeId || 0);
    const allFields = (0, useWorkflowFields_1.useWorkflowFields)({
        id: data === null || data === void 0 ? void 0 : data.entityId,
        tableName: data === null || data === void 0 ? void 0 : data.entityTable
    });
    const fields = hideCustomFields
        ? allFields.filter(field => !field.isCustom)
        : allFields;
    const selectedFields = fields.filter(field => selected.includes(field.value));
    const hasFields = fields.length > 0;
    const noSelected = selected.length === 0;
    const allSelected = fields.every(field => selected.includes(field.value));
    const partialSelected = !allSelected && fields.some(field => selected.includes(field.value));
    const label = allSelected
        ? 'Deselect All Fields'
        : noSelected || partialSelected
            ? 'Select All Fields'
            : 'Toggle Fields';
    const [entityFields, customFields] = (0, react_1.useMemo)(() => {
        return fields.reduce((result, field) => {
            result[+!!field.isCustom].push(field);
            return result;
        }, [[], []]);
    }, [fields]);
    const handleToggle = () => {
        if (allSelected) {
            // deselect all
            onChange === null || onChange === void 0 ? void 0 : onChange([]);
        }
        else if (noSelected || partialSelected) {
            // select all
            onChange === null || onChange === void 0 ? void 0 : onChange(fields);
        }
    };
    const handleChange = (field) => {
        const copy = Array.from(selectedFields);
        const existingIndex = copy.findIndex(item => item.value === field.value);
        if (existingIndex >= 0) {
            copy.splice(existingIndex, 1);
        }
        else {
            copy.push(field);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(copy);
    };
    const renderFields = (fields) => {
        return fields.map((field, index) => (react_1.default.createElement(core_1.FormControlLabel, { label: field.label, key: `${field.value}-${index}`, control: react_1.default.createElement(core_1.Checkbox, { color: 'primary', name: field.value, checked: selected.includes(field.value), onChange: () => handleChange(field) }) })));
    };
    (0, react_1.useEffect)(() => {
        taskTypeId && get({ id: taskTypeId });
    }, [taskTypeId, get]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        error && react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message),
        react_1.default.createElement(core_1.FormControlLabel, { label: label, style: { paddingLeft: 8 }, control: react_1.default.createElement(core_1.Checkbox, { name: 'toggle', color: 'primary', disabled: !hasFields, indeterminate: partialSelected, checked: hasFields && allSelected, onChange: handleToggle }) }),
        react_1.default.createElement(core_1.Divider, null),
        react_1.default.createElement(core_1.FormGroup, { style: { paddingLeft: 8 } },
            entityFields.length === 0 && (react_1.default.createElement(core_1.Box, { my: 2 },
                react_1.default.createElement(core_1.Typography, { variant: 'body1' }, isLoading
                    ? 'Loading fields...'
                    : 'There are no fields for this entity.'))),
            renderFields(entityFields),
            customFields.length > 0 && react_1.default.createElement(core_1.Divider, null),
            renderFields(customFields))));
};
exports.FieldPicker = FieldPicker;
exports.default = exports.FieldPicker;
//# sourceMappingURL=FieldPicker.js.map